import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { SEMANAS } from '../../constants/semanas';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';

@Component({
  selector: 'sgt-novo-semana-multi-select',
  templateUrl: './novo-semana-multi-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoSemanaMultiSelectComponent),
      multi: true,
    },
  ],
})
export class NovoSemanaMultiSelectComponent extends CustomControlValueAccessor<number[]> implements OnInit {
  @Input() idsSemanas: number[];
  @Output() idsSemanasChange = new EventEmitter<number[]>();
  @Input() settings!: IMultiSelectSettings;

  defaultSettings: IMultiSelectSettings = {
    placeholder: 'Semanas',
    singular: 'Semana',
    plural: 'Semanas',
    showFooter: false,
  };

  options: IOption[] = [];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.settings = { ...this.defaultSettings, ...this.settings };
    this.options = SEMANAS.map((semana) => ({
      id: semana.id,
      label: semana.nome,
      isChecked: false,
    }));
  }

  protected updateValue(newValue: number[] | null): void {
    const ids = newValue ?? [];
    this.idsSemanas = ids;
    this.options.forEach((o) => {
      o.isChecked = ids.includes(o.id);
    });
  }

  onSearch(): void {
    this.idsSemanasChange.emit(this.idsSemanas);
  }

  onSelectionChange(): void {
    this.emitChange(this.idsSemanas);
    this.markAsTouched();
  }
}
